module.exports = require("react-slick");


//////////////////
// WEBPACK FOOTER
// external "react-slick"
// module id = 29
// module chunks = 0